import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as http from "./assets/js/http";
import * as utils from "./assets/js/utils";
import "animate.css";

Vue.config.ignoredElements = ["wx-open-launch-weapp"];
Vue.config.productionTip = false;
Vue.prototype.$ossRes = (v) => {
  return process.env.VUE_APP_RESOURCE_URL + v;
};
Vue.prototype.$http = http;
Vue.prototype.$utils = utils;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
